import { createTheme } from '@mui/material/styles';
import '@fontsource/inter';   

const theme = createTheme({
  palette: {
    primary: {
      main: '#3366CC',
      light: '#3366CC'
    },
    secondary: {
      main: '#42A5F5',
      light: '#29EFDB',
      dark:'#45DFB1'
    }, 
    background: {
      default: '#FFFFFF',  
      paper: '#F5F5F5',
    },
    divider:'#F3F7FA',
    text: {
      primary: '#1a366e',
      secondary: '#FFFFFF', 
      disabled: '#d9d9d9', 
    },
    error: {
      light: '#FFCFCF',
      main: '#FF0000',
      dark: '#D70000',
      contrastText: '#cc0000'
    },
    info: {
      main: '#0000FF',
      dark: '#bae6ff',  
      light: '#FAFAFA', 
    },
    action:{
      hover:'#FFFFFF', 
      disabled:'#A9A9A9',
      disabledBackground:'#919191',
      focus:'#e8e8e8'
    },
    common:{
      white:'#FFFFFF', 
      black:'#303030', 
    },
    success: {
      light: '#AFE1AF',
      main: '#5cb85c',
      dark: '#387d38',
    },
    warning: {
      main: '#ffab33',
      light: '#fae8af',
      dark: '#ff9f17', 
      contrastText: '#c9c904'
    } 
  },
  spacing: 8,
  typography: {  
      fontFamily: "'Tajawal', sans-serif",
      body1: { 
        fontSize: '1rem',
        fontWeight: 400,
        color: '#1a366e',
      },
      body2: { 
        fontSize: '0.9rem',
        fontWeight: 400,
        color: '#1a366e',
      },
    h1: {
      fontSize: '2.8rem',
      fontWeight: 600,
      color: '#1a366e',
    },
    h2: {
      fontSize: '2.4rem',
      fontWeight: 500,
      color: '#1a366e',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#1a366e',
    },
    h4: {
      fontSize: '1.8rem',
      fontWeight: 500,
      color: '#1a366e',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#1a366e',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#1a366e',
    }, 
    button: {
      fontSize: '1rem',
      fontWeight: 500,
      textTransform: 'none',
    }, 
  },
  shape: {
    borderRadius: 6,
  },
});

export default theme;
